"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_checkbox_1 = tslib_1.__importDefault(require("rc-checkbox"));
var ref_1 = require("rc-util/lib/ref");
var config_provider_1 = require("../config-provider");
var context_1 = tslib_1.__importDefault(require("./context"));
var InternalRadio = function (props, ref) {
    var _a;
    var context = React.useContext(context_1.default);
    var _b = React.useContext(config_provider_1.ConfigContext), getPrefixCls = _b.getPrefixCls, direction = _b.direction;
    var innerRef = React.useRef();
    var mergedRef = (0, ref_1.composeRef)(ref, innerRef);
    var onChange = function (e) {
        if (props.onChange) {
            props.onChange(e);
        }
        if (context === null || context === void 0 ? void 0 : context.onChange) {
            context.onChange(e);
        }
    };
    var customizePrefixCls = props.prefixCls, className = props.className, children = props.children, style = props.style, restProps = tslib_1.__rest(props, ["prefixCls", "className", "children", "style"]);
    var prefixCls = getPrefixCls('radio', customizePrefixCls);
    var radioProps = tslib_1.__assign({}, restProps);
    if (context) {
        radioProps.name = context.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === context.value;
        radioProps.disabled = props.disabled || context.disabled;
    }
    var wrapperClassString = (0, classnames_1.default)("".concat(prefixCls, "-wrapper"), (_a = {},
        _a["".concat(prefixCls, "-wrapper-checked")] = radioProps.checked,
        _a["".concat(prefixCls, "-wrapper-disabled")] = radioProps.disabled,
        _a["".concat(prefixCls, "-wrapper-rtl")] = direction === 'rtl',
        _a), className);
    return (React.createElement("label", { className: wrapperClassString, style: style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
        // @ts-ignore
        React.createElement(rc_checkbox_1.default, tslib_1.__assign({}, radioProps, { prefixCls: prefixCls, ref: mergedRef })),
        children !== undefined ? React.createElement("span", null, children) : null));
};
var Radio = React.forwardRef(InternalRadio);
Radio.displayName = 'Radio';
Radio.defaultProps = {
    type: 'radio',
};
exports.default = Radio;
//# sourceMappingURL=radio.js.map